import { render, staticRenderFns } from "./RepasseSinteticoRead.vue?vue&type=template&id=6b9b8906&"
import script from "./RepasseSinteticoRead.vue?vue&type=script&lang=js&"
export * from "./RepasseSinteticoRead.vue?vue&type=script&lang=js&"
import style0 from "./RepasseSinteticoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports